import apiClient from '../client';

const searchService = {
  // Recherche globale dans toutes les entités
  search: async (query) => {
    try {
      const response = await apiClient.get(`/search?q=${encodeURIComponent(query)}`);
      return response.data;
    } catch (error) {
      console.error('Erreur recherche:', error);
      throw error;
    }
  },

  // Recherche par type d'entité
  searchAgents: async (query) => {
    try {
      const response = await apiClient.get(`/search/agents?q=${encodeURIComponent(query)}`);
      return response.data;
    } catch (error) {
      console.error('Erreur recherche agents:', error);
      return [];
    }
  },

  searchConversations: async (query) => {
    try {
      const response = await apiClient.get(`/search/conversations?q=${encodeURIComponent(query)}`);
      return response.data;
    } catch (error) {
      console.error('Erreur recherche conversations:', error);
      return [];
    }
  },

  searchProducts: async (query) => {
    try {
      const response = await apiClient.get(`/search/products?q=${encodeURIComponent(query)}`);
      return response.data;
    } catch (error) {
      console.error('Erreur recherche produits:', error);
      return [];
    }
  },

  searchOrders: async (query) => {
    try {
      const response = await apiClient.get(`/search/orders?q=${encodeURIComponent(query)}`);
      return response.data;
    } catch (error) {
      console.error('Erreur recherche commandes:', error);
      return [];
    }
  },

  searchKnowledge: async (query) => {
    try {
      const response = await apiClient.get(`/search/knowledge?q=${encodeURIComponent(query)}`);
      return response.data;
    } catch (error) {
      console.error('Erreur recherche base de connaissances:', error);
      return [];
    }
  }
};

export default searchService;
